export default function MySQL_YEARWEEK() {
  return (
    <div>
      <h2>MySQL_YEARWEEK</h2>    </div>
  );
}